"use client";

import { Tab, Tabs } from "react-bootstrap";
import Description from './Description';
import { Product } from "../../../../store/cart-store";

const ProductDescription= ({product}: {product: Product}) => {
  return (
    <>
      <Tabs
        defaultActiveKey="description"
        id="uncontrolled-tab-example"
        className="border-0 bg-transparen review-tabs"
      >
        <Tab eventKey="description" title="Description">
          <Description product={product} />
        </Tab>

        {/* <Tab eventKey="specification" title="Specification">
          <Specification />
        </Tab>

        <Tab eventKey="reviews" title="Reviews">
          <Reviews />
        </Tab> */}
      </Tabs>
    </>
  )
}

export default ProductDescription;